module.exports = __webpack_public_path__ + "media/dorobek/assets/images/icons/Flask-26bcf8ff43d851cf7583781820726444.svg";